import { format } from 'date-fns'

/**
 * Генерирует имя файла для экспорта с текущей датой и временем
 */
export const generateExportFilename = (exportType: string): string => {
  const timestamp = format(new Date(), 'yyyy-MM-dd_HH-mm-ss')
  return `${exportType}_${timestamp}.csv`
}

